import AddAttestationService from "../Attestation/AddAttestationService";
import AttestationLoginForm from "../Attestation/AttestationLoginForm";
import AttestationMainScreen from "../Attestation/AttestationMainScreen";
import DeliveryInformation from "../Attestation/DeliveryInformation";
import MainStepperAttestation from "../Attestation/MainStepperAttestation";
import MyRequest from "../Attestation/MyRequest";
// import NRP from '../Attestation/NRP';
import NRPLogin from "../Attestation/NRPLogin";
import Payment from "../Attestation/Payment";
import RegistrationForm from "../Attestation/RegistrationForm";
import ShipperInformation from "../Attestation/ShipperInformation";
import BecomeAFranchise from "../components/common/BecomeAFranchise";
import AttestationServices from "../components/Pages/AttestationServices";

import Brands from "../components/Pages/Brands";

// import LTLServices from '../components/Pages/TcsLogistics/ColdChain/LTLServices';
// import Storage from '../components/Pages/TcsLogistics/ColdChain/Storage';
// import TemperatureControlTransportation from '../components/Pages/TcsLogistics/ColdChain/TemperatureControlTransportation';
import AirportCustoms from "../components/Pages/TcsLogistics/CustomsBokerage/AirportCustoms";
import BorderCustoms from "../components/Pages/TcsLogistics/CustomsBokerage/BorderCustoms";
import Documentations from "../components/Pages/TcsLogistics/CustomsBokerage/Documentations";
import SeaPortCustoms from "../components/Pages/TcsLogistics/CustomsBokerage/SeaPortCustoms";
import InventoryManagement from "../components/Pages/TcsLogistics/Distribution/InventoryManagement";
import PrimaryDistribution from "../components/Pages/TcsLogistics/Distribution/PrimaryDistribution";
import SecondaryDistribution from "../components/Pages/TcsLogistics/Distribution/SecondaryDistribution";
import WareHousing from "../components/Pages/TcsLogistics/Distribution/WareHousing";
import International from "../components/Pages/International/International";
import Domestic from "../components/Pages/Domestic/Domestic";
import Logistics from "../components/Pages/Logistic/Logistics";
import Express from "../components/Pages/Express/Express";

import EmployeeBenefits from "../components/Pages/EmployeeBenefits";
import EmployeeCulture from "../components/Pages/EmployeeCulture";

import ColdChainTransportation from "../components/Pages/TcsLogistics/FleetTransportation/ColdChainTransportation";
import PrimaryTransportation from "../components/Pages/TcsLogistics/FleetTransportation/PrimaryTransportation";
import ProjectSpecializTransportation from "../components/Pages/TcsLogistics/FleetTransportation/ProjectSpecializTransportation";
import SecondaryTransportation from "../components/Pages/TcsLogistics/FleetTransportation/SecondaryTransportation";

import AirFreight from "../components/Pages/TcsLogistics/InternationalFreight/AirFreight";

import MoinAhmedMalik from "../components/Pages/Leadership/MoinAhmedMalik";
import MuneezaKassim from "../components/Pages/Leadership/MuneezaKassim";
import NasirNasrullah from "../components/Pages/Leadership/NasirNasrullah";
import QasimAwan from "../components/Pages/Leadership/QasimAwan";
import SaadiaAwan from "../components/Pages/Leadership/SaadiaAwan";
import SairaAwanMalik from "../components/Pages/Leadership/SairaAwanMalik";
import OpenAccount from "../components/Pages/OpenAccount";
import HamidFarooq from "../components/Pages/Leadership/HamidFarooq.js";
import AbdulQadir from "../components/Pages/Leadership/AbdulQadir.js";

import Transportation from "../components/Pages/OverLandLogistics/Transportation";

import ExhibitionEventsLogistics from "../components/Pages/TcsLogistics/ExpoLogistics/ExhibitionEventLogistics";
import Responsive from "../components/Pages/Responsive";
import TcsExpress from "../components/Pages/TcsExpress";
import TcsLogistics from "../components/Pages/TcsLogistics";

import TrainingandDevelopment from "../components/Pages/TrainingandDevelopment";

import DomesticExpressRoutes from "../components/Pages/TCS-Express/Domestic-Express/DomesticExpressRoutes";
import DomesticExpress from "../components/Pages/TCS-Express/Domestic-Express/DomesticExpress";
import AviationRoutes from "../components/Pages/TCS-Express/Aviation/AviationRoutes";
import Aviation from "../components/Pages/TCS-Express/Aviation/Aviation";
import RegUndertaking from "../components/Pages/RegUndertaking";
import TermsAndCond from "../components/Pages/TermsAndCond";
import {
  Dashboard,
  Mainpage,
  Careers,
  ClaimForm,
  Track,
  Platform,
  RateCalculator,
  Corporate,
  LeaderShip,
  CsrTcsFoundation,
  DayInTheLifeOfTcs,
  MailManagement,
  Mission,
  CustomerService,

  // OpenAccount,
  TCSFounder,
  Policy,
  Terms,
  Fraud,
  TcsPlugins,
  TcsKardo,
  TcsEcom,
  Faqs,
  NearYou,
  Rates,
  Login,
  About,
  SupplyRoutes,
  DomesticRoutes,
  InternationalRoutes,
  ValueAddedRoutes,
  ExpressRoutes,
  LogisticsRoutes,
} from "./modules";
import MileStone from "../components/Pages/International/MileStone";
import RedBox from "../components/Pages/TCS-Express/Domestic-Express/RedBoxs";
import ExpressFlyer from "../components/Pages/TCS-Express/Domestic-Express/ExpressFlyers.js";

import StudentExpress from "../components/Pages/TCS-Express/Domestic-Express/StudentExpresss";

import GSA from "../components/Pages/TCS-Express/Aviation/GSA";
import AirCargo from "../components/Pages/TCS-Express/Aviation/AirCargo";
import Chartered from "../components/Pages/TCS-Express/Aviation/Chartered";
import RushDelivery from "../components/Pages/TCS-Express/Aviation/RushDelivery";
import VisatronixRoutes from "../components/Pages/TCS-Express/VisaTronix/VisatronixRoutes";
import Visatronix from "../components/Pages/TCS-Express/VisaTronix/Visatronix";
import FamilyReunion from "../components/Pages/TCS-Express/VisaTronix/FamilyReunion";
import LegalizationDocuments from "../components/Pages/TCS-Express/VisaTronix/LegalizationDocuments";
import NationalityVisa from "../components/Pages/TCS-Express/VisaTronix/NationalityVisa";
import StudyVisa from "../components/Pages/TCS-Express/VisaTronix/StudyVisa";
import InternationalExpressRoutes from "../components/Pages/TCS-Express/InternationalExpress/InternationalExpressRoutes";
import InternationalExpress from "../components/Pages/TCS-Express/InternationalExpress/InternationalExpress";
import MMSRoutes from "../components/Pages/TCS-Express/MMS/MMSRoutes";
import MMS from "../components/Pages/TCS-Express/MMS/MMS";
import AutomaticStuffing from "../components/Pages/TCS-Express/MMS/AutomaticStuffing";
import BulkMailProjectManage from "../components/Pages/TCS-Express/MMS/BulkMailProjectManage";
import CustomizedSolutions from "../components/Pages/TCS-Express/MMS/CustomizedSolutions";
import Delivery from "../components/Pages/TCS-Express/MMS/Delivery";
import DigitalPrinting from "../components/Pages/TCS-Express/MMS/DigitalPrinting";
import MailRoomManagement from "../components/Pages/TCS-Express/MMS/MailRoomManagement";
import NormalBulkShipment from "../components/Pages/TCS-Express/MMS/NormalBulkShipment";
import IntianaTravelTours from "../components/Pages/TCS-Express/IntianaTravelTours/IntianaTravelTours";
import IntianaTravelToursRoutes from "../components/Pages/TCS-Express/IntianaTravelTours/IntianaTravelToursRoutes";
import AirTicketing from "../components/Pages/TCS-Express/IntianaTravelTours/AirTicketing";
import BusinessTravel from "../components/Pages/TCS-Express/IntianaTravelTours/BusinessTravel";
import DomesticInternationalTours from "../components/Pages/TCS-Express/IntianaTravelTours/DomesticInternationalTours";
import LeisureTravel from "../components/Pages/TCS-Express/IntianaTravelTours/LeisureTravel";
import UmrahPackages from "../components/Pages/TCS-Express/IntianaTravelTours/UmrahPackages";
import CVIShipmentInsurance from "../components/Pages/TCS-Express/FinancialServices/CVIShipmentInsurance";
import PersonalInsurance from "../components/Pages/TCS-Express/FinancialServices/PersonalInsurance";
import MotorInsurance from "../components/Pages/TCS-Express/FinancialServices/MotorInsurance";
import STIHealthInsurance from "../components/Pages/TCS-Express/FinancialServices/STIHealthInsurance";
import FinancialServices from "../components/Pages/TCS-Express/FinancialServices/FinancialServices";
import FinancialServicesRoutes from "../components/Pages/TCS-Express/FinancialServices/FinancialServicesRoutes";
import Warehousing from "../components/Pages/TcsLogistics/Warehousing/Warehousing";
import WarehousingRoutes from "../components/Pages/TcsLogistics/Warehousing/WarehousingRoutes";

import RecordsManagement from "../components/Pages/TcsLogistics/Warehousing/RecordsManagement";
import TemperatureControlledAmbient from "../components/Pages/TcsLogistics/Warehousing/TemperatureControlledAmbient";
import ValueAddedServices from "../components/Pages/TcsLogistics/Warehousing/ValueAddedServices";
import OverlandLogistics from "../components/Pages/TcsLogistics/OverlandLogistics/OverlandLogistics";
import OverlandLogisticsRoutes from "../components/Pages/TcsLogistics/OverlandLogistics/OverlandLogisticsRoutes";
import EcomSolutionRoutes from "../components/Pages/TCS-Express/EcomSolution/EcomSolutionRoutes";
import EcomSolutions from "../components/Pages/TCS-Express/EcomSolution/EcomSolutions";
import CashOnDelivery from "../components/Pages/TCS-Express/EcomSolution/CashOnDelivery";
import QuickPayments from "../components/Pages/TCS-Express/EcomSolution/QuickPayments";
import DoorToDoor from "../components/Pages/TcsLogistics/OverlandLogistics/DoorToDoor";
import TemperatureControl from "../components/Pages/TcsLogistics/OverlandLogistics/TemperatureControl";
import DryCargo from "../components/Pages/TcsLogistics/OverlandLogistics/DryCargo";
import CustomizedSolution from "../components/Pages/TcsLogistics/OverlandLogistics/CustomizeSolutions";
import HubToHub from "../components/Pages/TcsLogistics/OverlandLogistics/HubToHub";
import TcsFresh from "../components/Pages/TcsLogistics/OverlandLogistics/TcsFresh";
import EcomSegment from "../components/Pages/TcsLogistics/OverlandLogistics/EcomSegment";

import RoadFreight from "../components/Pages/TcsLogistics/InternationalFreight/RoadFreight";
import SeaFreight from "../components/Pages/TcsLogistics/InternationalFreight/SeaFreight";

import InternationalFreights from "../components/Pages/TcsLogistics/InternationalFreight/InternationalFreights";
import InternationalFreightRoutes from "../components/Pages/TcsLogistics/InternationalFreight/InternationalFreightsRoutes";
import ProjectLogistics from "../components/Pages/TcsLogistics/ProjectLogistics/ProjectLogistics";
import ProjectLogisticsRoutes from "../components/Pages/TcsLogistics/ProjectLogistics/ProjectLogisticsRoutes";
import ProfessionalTeam from "../components/Pages/TcsLogistics/ProjectLogistics/ProfessionalTeam";

import FleetTransportations from "../components/Pages/TcsLogistics/FleetTransportation/FleetTransportations";
import FleetTransportationsRoutes from "../components/Pages/TcsLogistics/FleetTransportation/FleetTransportationsRoutes";
import Distributions from "../components/Pages/TcsLogistics/Distribution/Distributions";
import DistributionsRoutes from "../components/Pages/TcsLogistics/Distribution/DistributionsRoutes";
import CustomsBokerages from "../components/Pages/TcsLogistics/CustomsBokerage/CustomsBokerages";
import CustomsBokeragesRoutes from "../components/Pages/TcsLogistics/CustomsBokerage/CustomsBokeragesRoutes";
import ColdChains from "../components/Pages/TcsLogistics/ColdChain/ColdChains";
import ColdChainsRoutes from "../components/Pages/TcsLogistics/ColdChain/ColdChainsRoutes";
import RegionalTradesRoutes from "../components/Pages/TcsLogistics/TIRRegionalTrade/RegionalTradesRoutes";
import RegionalTrades from "../components/Pages/TcsLogistics/TIRRegionalTrade/RegionalTrades";
import PacknGOs from "../components/Pages/TcsLogistics/PackNGo/PacknGos";
import AgriLogisticss from "../components/Pages/TcsLogistics/AgriLogistics/AgriLogisticss";
import ExpoLogistics from "../components/Pages/TcsLogistics/ExpoLogistics/ExpoLogistics";

import AboutUsRoutes from "../components/Pages/AboutUsRoutes";
import PickupRequest from "../components/Pages/PickupRequest";
import SchedulePickUp from "../components/Pages/SchedulePickUp";
import MmsForm from "../components/Pages/MmsForm";
import Overland from "../components/Pages/Overland";
import LaptopFaqs from "../components/Pages/LaptopFaqs";
import CustomerServicesRoutes from "../components/Pages/CustomerServicesRoutes";
import termsNconds from "../components/Pages/Terms&Conds";
import FleetTransportation from "../components/Pages/Logistic/FleetTransportation";
const defineRoutes = [
  { routeName: "/", component: Mainpage, props: {} },
  {
    routeName: "/dashboard",
    component: Dashboard,
    props: { data: "something" },
  },
  { routeName: "/careers", component: Careers, props: {} },

  { routeName: "/claimform", component: ClaimForm, props: {} },

  { routeName: "/corporate", component: Corporate, props: {} },

  { routeName: "/platform-solutions/:id", component: Platform, props: {} },

  { routeName: "/leadership", component: LeaderShip, props: {} },

  { routeName: "/mile-stone", component: MileStone, props: {} },
  { routeName: "/laptop-faqs", component: LaptopFaqs, props: {} },

  { routeName: "/track/*", component: Track, props: {} },

  { routeName: "/ratecalculator", component: RateCalculator, props: {} },

  { routeName: "/csr-tcs-foundation", component: CsrTcsFoundation, props: {} },
  { routeName: "/open-account", component: OpenAccount, props: {} },

  {
    routeName: "/day-in-the-life-Of-tcs",
    component: DayInTheLifeOfTcs,
    props: {},
  },
  {
    routeName: "/mail-management",
    component: MailManagement,
    props: {},
  },

  { routeName: "/mission", component: Mission, props: {} },
  {
    routeName: "/customer-services",
    component: CustomerService,
    props: {},
  },
  {
    routeName: "/customer-services/*",
    component: CustomerServicesRoutes,
    props: {},
  },
  {
    routeName: "/trainingdevelopment",
    component: TrainingandDevelopment,
    props: {},
  },
  {
    routeName: "/employeeculture",
    component: EmployeeCulture,
    props: {},
  },
  {
    routeName: "/employeebenefits",
    component: EmployeeBenefits,
    props: {},
  },
  {
    routeName: "/brands",
    component: Brands,
    props: {},
  },
  {
    routeName: "/tcsexpress",
    component: TcsExpress,
    props: {},
  },
  {
    routeName: "/tcslogistics",
    component: TcsLogistics,
    props: {},
  },

  {
    routeName: "/domestic-express/*",
    component: DomesticExpressRoutes,
    props: {},
  },
  { routeName: "/domestic-express/", component: DomesticExpress, props: {} },
  { routeName: "/aviation/*", component: AviationRoutes, props: {} },
  { routeName: "/aviation/", component: Aviation, props: {} },

  { routeName: "/visatronix/*", component: VisatronixRoutes, props: {} },
  { routeName: "/visatronix/", component: Visatronix, props: {} },
  { routeName: "/mms/*", component: MMSRoutes, props: {} },
  { routeName: "/mms/", component: MMS, props: {} },

  { routeName: "/ecom-solution/", component: EcomSolutions, props: {} },
  { routeName: "/ecom-solution/*", component: EcomSolutionRoutes, props: {} },

  {
    routeName: "/international-express/*",
    component: InternationalExpressRoutes,
    props: {},
  },
  {
    routeName: "/international-express/",
    component: InternationalExpress,
    props: {},
  },

  { routeName: "/intiana-travel/", component: IntianaTravelTours, props: {} },
  {
    routeName: "/intiana-travel/*",
    component: IntianaTravelToursRoutes,
    props: {},
  },

  {
    routeName: "/financial-services/",
    component: FinancialServices,
    props: {},
  },
  {
    routeName: "/financial-services/*",
    component: FinancialServicesRoutes,
    props: {},
  },

  { routeName: "/warehousing/", component: Warehousing, props: {} },
  { routeName: "/warehousing/*", component: WarehousingRoutes, props: {} },

  { routeName: "/about/*", component: AboutUsRoutes, props: {} },

  { routeName: "/pack-n-go/", component: PacknGOs, props: {} },

  {
    routeName: "/international-freights/",
    component: InternationalFreights,
    props: {},
  },
  {
    routeName: "/international-freights/*",
    component: InternationalFreightRoutes,
    props: {},
  },

  { routeName: "/project-logistics/", component: ProjectLogistics, props: {} },
  {
    routeName: "/project-logistics/*",
    component: ProjectLogisticsRoutes,
    props: {},
  },

  {
    routeName: "/overland-logistics/",
    component: OverlandLogistics,
    props: {},
  },
  {
    routeName: "/overland-logistics/*",
    component: OverlandLogisticsRoutes,
    props: {},
  },

  { routeName: "/agri-logistics/", component: AgriLogisticss, props: {} },
  { routeName: "/agri-logistics", component: AgriLogisticss, props: {} },

  { routeName: "/expo-logistics/", component: ExpoLogistics, props: {} },
  { routeName: "/expo-logistics", component: ExpoLogistics, props: {} },
  {
    routeName: "/fleet-transportation/",
    component: FleetTransportations,
    props: {},
  },
  {
    routeName: "/fleet-transportation/*",
    component: FleetTransportationsRoutes,
    props: {},
  },

  { routeName: "/distribution/", component: Distributions, props: {} },
  { routeName: "/distribution/*", component: DistributionsRoutes, props: {} },

  { routeName: "/customs-bokerage/", component: CustomsBokerages, props: {} },
  {
    routeName: "/customs-bokerage/*",
    component: CustomsBokeragesRoutes,
    props: {},
  },

  { routeName: "/coldchain/", component: ColdChains, props: {} },
  { routeName: "/coldchain/*", component: ColdChainsRoutes, props: {} },

  { routeName: "/regional-trade/", component: RegionalTrades, props: {} },

  {
    routeName: "/regional-trade/*",
    component: RegionalTradesRoutes,
    props: {},
  },

  { routeName: "/regional-trade", component: RegionalTrades, props: {} },

  { routeName: "/domestic/", component: Domestic, props: {} },
  { routeName: "/domestic/*", component: DomesticRoutes, props: {} },
  { routeName: "/express/", component: Express, props: {} },
  { routeName: "/express/*", component: ExpressRoutes, props: {} },
  { routeName: "/logistics/", component: Logistics, props: {} },
  { routeName: "/logistics/*", component: LogisticsRoutes, props: {} },
  { routeName: "/international/", component: International, props: {} },
  { routeName: "/international/*", component: InternationalRoutes, props: {} },
  {
    routeName: "/value-added-services/*",
    component: ValueAddedRoutes,
    props: {},
  },

  { routeName: "/supply-chain/*", component: SupplyRoutes, props: {} },
  { routeName: "/founder", component: TCSFounder, props: {} },

  { routeName: "/privacy-policy", component: Policy, props: {} },

  { routeName: "/terms-of-use", component: Terms, props: {} },

  { routeName: "/fraud-prevention", component: Fraud, props: {} },
  { routeName: "/plugins", component: TcsPlugins, props: {} },
  { routeName: "/tcs-kardo", component: TcsKardo, props: {} },
  { routeName: "/ecom", component: TcsEcom, props: {} },
  { routeName: "/faqs", component: Faqs, props: {} },
  { routeName: "/tcs-nearyou", component: NearYou, props: {} },
  {
    routeName: "/attestationservices",
    component: AttestationServices,
    props: {},
  },
  //Projectlogistics
  { routeName: "/project-logistics", component: ProjectLogistics, props: {} },
  { routeName: "/rates", component: Rates, props: {} },
  { routeName: "/customer-portals", component: Login, props: {} },
  { routeName: "/about", component: About, props: {} },
  { routeName: "/become-Franchise", component: BecomeAFranchise, props: {} },

  // LeaderShip
  { routeName: "/saadia-awan", component: SaadiaAwan, props: {} },
  { routeName: "/qasim-awan", component: QasimAwan, props: {} },
  { routeName: "/nasir-nasrullah", component: NasirNasrullah, props: {} },
  { routeName: "/muneeza-kassim", component: MuneezaKassim, props: {} },
  { routeName: "/moin-ahmed-malik", component: MoinAhmedMalik, props: {} },
  { routeName: "/saira-awan-malik", component: SairaAwanMalik, props: {} },
  { routeName: "/hamid-farooq", component: HamidFarooq, props: {} },
  { routeName: "/abdul-qadir-aziz", component: AbdulQadir, props: {} },

  // LeaderShip

  { routeName: "/regundertaking", component: RegUndertaking, props: {} },
  { routeName: "/termsandcond", component: TermsAndCond, props: {} },
  // TCS EXPRESS
  // DomesticExpress

  // { routeName: "/attestationservices", component: AttestationServicess, props: {} },
  // { routeName: "/overnight", component: OverNights, props: {} },
  // { routeName: "samedaydelivery", component: SameDayDeliverys, props: {} },
  // { routeName: "/2nddaydelivery", component: SecondDayDeliverys, props: {} },
  // { routeName: "/timechoicedelivery", component: TimeChoiceDeliverys, props: {} },
  // { routeName: "/redbox", component: RedBoxs, props: {} },

  // { routeName: "/attestation", component: EconomyExpresss, props: {} },
  { routeName: "/distribution", component: Distributions, props: {} },
  // { routeName: "/warehousing", component: Warehouses, props: {} },
  // { routeName: "/expressflyer", component: ExpressFlyers, props: {} },

  // { routeName: "/mehfoozexpress", component: MehfoozExpresss, props: {} },
  // { routeName: "/liquidshipping", component: LiquidShippings, props: {} },
  // { routeName: "/studentexpress", component: StudentExpresss, props: {} },
  // { routeName: "/ticketingservices", component: TicketingServicess, props: {} },
  // { routeName: "/pack-n-go", component: PackNGOs, props: {} },
  // { routeName: "/overlandexpress", component: OverlandExpresss, props: {} },

  // { routeName: "/codandcodplus", component: CODs, props: {} },
  // { routeName: "/paymentsolution", component: PaymentSolutions, props: {} },
  // { routeName: "/shipmentinsurance", component: ShipmentInsurances, props: {} },
  // { routeName: "/tcsfresh", component: TCSFreshs, props: {} },

  { routeName: "/ecom-solution", component: EcomSolutions, props: {} },
  { routeName: "/mms", component: MMS, props: {} },
  { routeName: "/coldchain", component: ColdChains, props: {} },
  { routeName: "/aviation", component: Aviation, props: {} },

  // DomesticExpress
  { routeName: "/pickup-request", component: PickupRequest, props: {} },
  { routeName: "/schedulePickUp", component: SchedulePickUp, props: {} },
  // InternationalExpress
  { routeName: "/redbox", component: RedBox, props: {} },
  { routeName: "/express-flyer", component: ExpressFlyer, props: {} },
  { routeName: "/student-express", component: StudentExpress, props: {} },
  {
    routeName: "/attestation-services",
    component: AttestationServices,
    props: {},
  },
  // InternationalExpress

  // Financial services
  { routeName: "/financial-services", component: FinancialServices, props: {} },
  { routeName: "/cvishipment", component: CVIShipmentInsurance, props: {} },
  { routeName: "/motorinsurance", component: MotorInsurance, props: {} },
  { routeName: "/personalinsurance", component: PersonalInsurance, props: {} },
  {
    routeName: "/stihealthinsurance",
    component: STIHealthInsurance,
    props: {},
  },
  // Financial services

  // Aviation
  { routeName: "/gsa", component: GSA, props: {} },
  { routeName: "/air-cargo", component: AirCargo, props: {} },
  { routeName: "/chartered", component: Chartered, props: {} },
  { routeName: "/rush-delivery", component: RushDelivery, props: {} },
  // Aviation

  // E-com Solution
  { routeName: "/cash-on-delivery", component: CashOnDelivery, props: {} },
  { routeName: "/quick-payment", component: QuickPayments, props: {} },
  { routeName: "/warehousing", component: Warehousing, props: {} },
  // E-com Solution

  // Visa Tronix
  { routeName: "/family-reunion", component: FamilyReunion, props: {} },
  { routeName: "/legalization", component: LegalizationDocuments, props: {} },
  { routeName: "/nationality-visa", component: NationalityVisa, props: {} },
  { routeName: "/study-visa", component: StudyVisa, props: {} },
  // Visa Tronix

  // Intiana Travel & Tours
  { routeName: "/air-ticketing", component: AirTicketing, props: {} },
  { routeName: "/Business-travel", component: BusinessTravel, props: {} },
  {
    routeName: "/domestic-int-tours",
    component: DomesticInternationalTours,
    props: {},
  },
  { routeName: "/leisure-travel", component: LeisureTravel, props: {} },
  { routeName: "/umrah-packages", component: UmrahPackages, props: {} },
  // Intiana Travel & Tours

  // MMS
  { routeName: "/automatic-stuffing", component: AutomaticStuffing, props: {} },
  {
    routeName: "/bulk-mail-project",
    component: BulkMailProjectManage,
    props: {},
  },
  {
    routeName: "/customized-solutions",
    component: CustomizedSolutions,
    props: {},
  },
  { routeName: "/delivery", component: Delivery, props: {} },
  { routeName: "/digital-printing", component: DigitalPrinting, props: {} },
  {
    routeName: "/mail-room-management",
    component: MailRoomManagement,
    props: {},
  },
  {
    routeName: "/normal-bulk-shipment",
    component: NormalBulkShipment,
    props: {},
  },

  // MMS

  // TCS EXPRESS

  // TCS Logistics
  // OverlandLogistics
  { routeName: "/door-to-door", component: DoorToDoor, props: {} },
  {
    routeName: "/temperature-control",
    component: TemperatureControl,
    props: {},
  },
  { routeName: "/dry-cargo", component: DryCargo, props: {} },
  { routeName: "/hub-to-hub", component: HubToHub, props: {} },
  { routeName: "/tcs-fresh", component: TcsFresh, props: {} },
  {
    routeName: "/customized-solutions",
    component: CustomizedSolution,
    props: {},
  },
  { routeName: "/ecom-segment", component: EcomSegment, props: {} },

  // OverlandLogistics

  // WareHousing
  { routeName: "/records-management", component: RecordsManagement, props: {} },
  {
    routeName: "/temperature-controlled-ambient",
    component: TemperatureControlledAmbient,
    props: {},
  },
  {
    routeName: "/value-added-services",
    component: ValueAddedServices,
    props: {},
  },

  // WareHousing

  // InternationalFreight
  { routeName: "/air-freight", component: AirFreight, props: {} },
  { routeName: "/road-freight", component: RoadFreight, props: {} },

  { routeName: "/sea-freight", component: SeaFreight, props: {} },
  // InternationalFreight

  // ProjectLogistics
  {
    routeName: "/exhibition-events-logistics",
    component: ExhibitionEventsLogistics,
    props: {},
  },
  { routeName: "/professional-team", component: ProfessionalTeam, props: {} },
  { routeName: "/track", component: Track, props: {} },
  { routeName: "/transportation", component: Transportation, props: {} },

  // ProjectLogistics

  // FleetTransportation
  {
    routeName: "/cold-chain-transportation",
    component: ColdChainTransportation,
    props: {},
  },
  {
    routeName: "/primary-transportation",
    component: PrimaryTransportation,
    props: {},
  },
  {
    routeName: "/project-sepecializ-transportation",
    component: ProjectSpecializTransportation,
    props: {},
  },
  {
    routeName: "/secondary-transportation",
    component: SecondaryTransportation,
    props: {},
  },
  // FleetTransportation
  {
    routeName: "/fleet-transportation",
    component: FleetTransportation,
    props: {},
  },

  // Distribution
  {
    routeName: "/inventory-management",
    component: InventoryManagement,
    props: {},
  },
  {
    routeName: "/primary-distribution",
    component: PrimaryDistribution,
    props: {},
  },
  {
    routeName: "/secondary-distribution",
    component: SecondaryDistribution,
    props: {},
  },
  { routeName: "/warehousing", component: WareHousing, props: {} },
  // Distribution
  // CustomsBrokerage
  { routeName: "/airport-customs", component: AirportCustoms, props: {} },
  { routeName: "/border-customs", component: BorderCustoms, props: {} },
  { routeName: "/seaport-customs", component: SeaPortCustoms, props: {} },
  { routeName: "/documentations", component: Documentations, props: {} },
  // CustomsBrokerage

  // Temperature Control Transportation
  // { routeName: "/temperature-control-transportations", component: TemperatureControlTransportation, props: {} },
  // { routeName: "/storage", component: Storage, props: {} },
  { routeName: "/distribution", component: Distributions, props: {} },
  // { routeName: "/ltl-services", component: LTLServices, props: {} },

  // Temperature Control Transportation

  // TCS Logistics

  //                   NRP Page
  { routeName: "/attestation", component: AttestationMainScreen, props: {} },
  { routeName: "/nrplogin", component: NRPLogin, props: {} },
  {
    routeName: "/attestation/add",
    component: AddAttestationService,
    props: {},
  },
  {
    routeName: "/attestation/deliveryinformation",
    component: DeliveryInformation,
    props: {},
  },
  { routeName: "/attestation/payment", component: Payment, props: {} },
  {
    routeName: "/attestationlogin",
    component: AttestationLoginForm,
    props: {},
  },
  { routeName: "/myrequest", component: MyRequest, props: {} },
  { routeName: "/registration", component: RegistrationForm, props: {} },
  {
    routeName: "/attestation/shipperinformation",
    component: ShipperInformation,
    props: {},
  },
  {
    routeName: "/attestation/mainStepper",
    component: MainStepperAttestation,
    props: {},
  },
  { routeName: "/responsive", component: Responsive, props: {} },

  { routeName: "/vistronix", component: Visatronix, props: {} },

  // Express
  { routeName: "/Vistronix", component: DomesticExpress, props: {} },
  // new forms of mms and overland similar to corporate form
  { routeName: "/overland", component: Overland, props: {} },
  { routeName: "/mmsForm", component: MmsForm, props: {} },
  { routeName: "/tnc", component: termsNconds, props: {} },
];

export default defineRoutes;
